import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {Header, Modal} from "semantic-ui-react";
import {
    FeedSummary,
    FeedEvent,
    FeedContent,
    CardHeader,
    CardContent,
    Card,
    Feed,
  } from 'semantic-ui-react'  
import ErrorMessage from '../ErrorMessage'
import {client} from '../../Client';
import PropTypes from 'prop-types';
import PreviewNewsForm from "./PreviewNewsForm";
import '../../styles/News.css'


class NewsToday extends Component {

    constructor(props) {
        super(props);
        this.state = {
            _loading: false,
            error: null,
            items: [],
            modalPreview: {size:'large'},
            redirectToModify: null
        };
        this.loadData = this.loadData.bind(this)
        this.onClickPreview = this.onClickPreview.bind(this);
        this.onClickPreviewEnd = this.onClickPreviewEnd.bind(this);
        this.onClickA = this.onClickA.bind(this);
        this.onClickB = this.onClickB.bind(this);
        this.onUpdateClick = this.onUpdateClick.bind(this);

    }

    onClickPreview(news) {
        this.setState({previewNews: {news}})        
    }
    onClickPreviewEnd(news){
        this.setState({previewNews: undefined})
    }
    onUpdateClick(news){
        this.setState({previewNews: undefined, redirectToModify: news});
    }
    onClickA(news){
        this.setState({_loading: true});
        client.updateNewsViewsByNewsAndUser(news.idNews, client.getCurrentUserId(), 3).then((response) => {
            if (response.ok){
                this.setState({
                    _loading: false,
                    error: null,
                    previewNews: undefined
                });
                this.loadData();
            }
            else if (response.status === 401)
            {
                this.props.history.push("/login")
            }
            else
            {
                response.json().then((errore) => {
                    this.setState({
                        _loading: false,
                        error: {title: errore.title, msg: errore.msg},
                        previewNews: undefined
                    });
                })
            }
        }).catch((error) => {
            this.setState({
                _loading: false,
                error: {title: "Errore di rete imprevisto", msg: error.message},
                previewNews: undefined
            });
        });

    }
    onClickB(news){
        this.setState({_loading: true});
        client.updateNewsViewsByNewsAndUser(news.idNews, client.getCurrentUserId(), 2).then((response) => {
            if (response.ok){
                this.setState({
                    _loading: false,
                    error: null,
                    previewNews: undefined
                });
                this.loadData();
            }
            else if (response.status === 401)
            {
                this.props.history.push("/login")
            }
            else
            {
                response.json().then((errore) => {
                    this.setState({
                        _loading: false,
                        error: {title: errore.title, msg: errore.msg},
                        previewNews: undefined
                    });
                })
            }
        }).catch((error) => {
            this.setState({
                _loading: false,
                error: {title: "Errore di rete imprevisto", msg: error.message},
                previewNews: undefined
            });
        });
    }

    componentDidMount() {
        this.loadData();
    }

    componentWillReceiveProps(nextProps, nextContext){
        this.loadData()
    }

    loadData() {
        this.setState({_loading: true});
        let f = null;
        if (this.props.mode === "all"){
            f = client.loadNewsAll(client.getCurrentUserId());
        }
        else if (this.props.mode === "today"){
            f = client.loadNewsToday(client.getCurrentUserId());
        }
        else{
            f = client.loadNewsLastWeek(client.getCurrentUserId());
        }
        f.then((response) => {
            if (response.ok)
            {
                response.json().then((data)=>{
                    this.setState({
                        items: data,
                        _loading: false,
                        error: null
                    })
                })
            }
            else if (response.status === 401)
            {
                this.props.history.push("/login")
            }
            else
            {
                response.json().then((data) => {
                    this.setState({
                        _loading: false,
                        error: {title: data.title, msg: data.msg}
                    })
                })
            }
        }).catch((error) => {
            this.setState({
                _loading: false,
                error: {title: "Errore di rete imprevisto", msg: error.message}
            })
        });
    }

    render() {

        if (this.state.error !== null)
        {
            return (<ErrorMessage title={this.state.error.title} msg={this.state.error.msg} />)
        }
        let redirectToMod = null;
        if (this.state.redirectToModify != null){
            let c = this.state.redirectToModify ;
             redirectToMod = (<Redirect to={`/app/news/edit/${c.idNews}`}/>);
             this.setState({redirectToModify: null});
        }

        let loader = '';
        if  (this.state._loading) {
            loader = (
                <div className="ui active inverted dimmer">
                <div className="ui loader"></div>
                </div>
            );
        }

        let previewNews = null;
        if (this.state.previewNews !== undefined){
            previewNews = (<Modal
                style={{height:'80%'}}
                open={this.state.previewNews !== undefined}
                size={this.state.modalPreview.size}
                closeIcon={false}
                onClose={this.onPreviewNewsEnd}
            >
                <Header icon='comments outline' content={this.state.previewNews.news.titolo} />
                <Modal.Content style={{height:'100%'}}>
                <PreviewNewsForm
                    item={this.state.previewNews.news}
                    showButtons={true}
                    onOkClick={this.onClickPreviewEnd}
                    onOkAClick={this.onClickA}
                    onOkBClick={this.onClickB}
                    onUpdateClick={this.onUpdateClick}
                />
                </Modal.Content>
            </Modal>)
        }

        let newsList =  this.state.items.map((item) => {
            return (<FeedEvent key={item.idNews}>
            <FeedContent>
                {/* <FeedDate><LocalDayOfWeek data={item.dataPubblicazione}/></FeedDate> */}
                <FeedSummary>
                <a href="#" onClick={()=>this.onClickPreview(item)}><span className={`newsstat_${item.uvisibile}`}>{item.titolo}</span></a> 
                {/* <Link to={`/app/news/edit/${item.idNews}`}><strong>{item.titolo}</strong></Link> */}
                {/* &nbsp;{getShortText(item.testo, 50)} */}
                </FeedSummary>
            </FeedContent>
            </FeedEvent>
            )
        });

        let newsTable = null;
        if (this.state.items.length <= 0){
            newsTable = <span>Nessuna news disponibile</span>
        }
        else {
            newsTable = <Feed style={{overflow: 'auto', maxHeight: "100%" }}>
                {newsList}
            </Feed>;
        }
        // style={{backgroundColor: this.props.backgroundColor,color: "#dddddd"}}
        return (
            <Card style={{height:"100%", backgroundColor:"#antiquewhite"}}>
            <CardContent>
                <CardHeader>{this.props.title}</CardHeader>
            </CardContent>
            <CardContent  style={{height:"100%"}}>
                {newsTable}
            </CardContent>
            {previewNews}
            {loader}
            {redirectToMod}
            </Card>
            
        )
    }
}

NewsToday.PropTypes = {
    titolo: PropTypes.string.isRequired,
    backgroundColor: PropTypes.string.isRequired,
    mode: PropTypes.string.isRequired // today/lastWeek/all
}

NewsToday.defaultProps = {
    titolo: "Oggi",
    mode: "today"
};

NewsToday.contextTypes = {
    router: PropTypes.object
}

export default NewsToday;




/** WEBPACK FOOTER **
 ** ./src/components/news/NewsToday.js
 **/